<template>
	<div style="background: #F7F7F7;margin-bottom: 30px;">
		<div class="center flex-x-bet-y-center flex-1">
		  <div class="flex-y-center flex-1">
		    <el-select v-model="queryParams.putType" @change="putTypeChan" :popper-append-to-body="false">
		      <el-option v-for="(item, index) in searchTypeList" :key="item.value" :value="item.value"
		        :label="item.label"></el-option>
		    </el-select>
		    <input type="text" @focus="handleFocus" v-model="queryParams.content" placeholder="请输入.." class="search-input" />
		  </div>
		  <i v-if="icon_del" class="el-icon-circle-close dels" @click="delInpurt"></i>
		  <div class="search-btn flex-xy-center" @click="getList">
		    <img src="@/assets/img/icon-search.png" class="icon-search" alt="" />
		  </div>
		</div>
		<div v-if="productInfo.length >= 1" class="product-list">
		  <product-item v-for="item in productInfo" :key="item" :productInfo="item" :id="item.id" :link="true" @link="link"></product-item>
		</div>
		<div v-else class="product-list noData">
		  <span>
		    暂无数据
		  </span>
		</div>
		<pagination v-show="total > 0" :pageSize="10" :pageSizes="[10, 20, 30, 50]" :total="total"
		  :page.sync="queryParams.pageNo" :limit.sync="queryParams.pageSize" @pagination="getList" />
	</div>
</template>

<script>
	import ProductItem from '@/components/ProductItem.vue';
	import { getsupplyList } from '@/api/manufacturerssupply.js';
	export default {
		name: "search",
		components: {
		  ProductItem
		},
		data() {
			return {
				searchTypeList: [
				  { label: "厂商", value: 1 },
				  { label: "二手", value: 2 },
				  { label: "租赁", value: 3 },
				],
				icon_del: false,//用来显示隐藏del
				productInfo: [],//数据
				queryParams: {
				  pageNo: 1,
				  pageSize: 50,
				  putType: 1,
				  content:''
				},
				total: 20,
			};
		},
		props:{
			firmId:{
				type:String,
				default:''
			},
			uid:{
				type:String,
				default:''
			},
		},
		methods: {
			delInpurt() {
			  this.queryParams.content = ''
			  this.icon_del = false
			},
			handleFocus() {//监听input聚焦
			  this.icon_del = true
			},
			putTypeChan(e){
				this.queryParams.putType = e
				this.getList(true)
			},
			getList(init=false) {//获取商品列表
				if (init) {
					this.productInfo = []
					this.queryParams.pageNo = 1
					this.queryParams.pageSize = 50
					this.total = 20
				}
				this.queryParams.firmId = this.firmId
			    getsupplyList(this.queryParams).then((res) => {
			      this.productInfo = res.result.records
			      this.total = res.result.total
			    })
			},
			link(productInfo){
				this.$emit('link',{data:productInfo,uid:this.uid})
			}
		},
	};
</script>

<style lang="scss" scoped>
	
	
	.center {
	  height: 100%;
	  position: relative;
	  margin: 0 50px 30px;
	  flex:1;
	  background: #ffffff;
	  border-radius: 0px;
	  border: 2px solid #fe5a13;
	  // height: 0.5625rem;
	
	  .search-input {
	    flex: 1;
	    border: 0;
	    outline: none;
	    border-left: 1px solid #ccc;
	    padding: 0 20px;
	    height: 35px;
	  }
	
	  input {
	    font-size: 18px;
	  }
	
	  ::v-deep .el-input__inner {
	    font-size: 18px;
	  }
	
	  ::v-deep .el-select-dropdown__item {
	    font-size: 18px;
	  }
	}
	
	.dels {
	  color: #818181;
	  font-size: 18px;
	  margin-right: 10px;
	}
	
	.search-btn {
	  width: 59px;
	  height: 40px;
	  background: #fe5a13;
	  cursor: pointer;
	
	  .icon-search {
	    width: 26px;
	    height: 26px;
	  }
	}
	

	::v-deep .el-input__inner {
	  border: 0;
	  width: 104px;
	}
	
	::v-deep .el-select {
	  position: relative;
	}
	
	// 下拉框选中修改文字颜色
	::v-deep .selected {
	  color: #fe5a13 !important;
	}
	
	.bigin:hover .twoMin {
	  display: block !important;
	}
	
	.allHeader:hover .oneMin {
	  display: block !important;
	
	}
	
	::v-deep .custom-drawer .el-drawer__header {
	  background-color: #F4F4F4;
	  /* 修改背景颜色 */
	  color: #333;
	  /* 修改文字颜色 */
	  font-size: 16px;
	  /* 修改文字大小 */
	  padding: 15px;
	  /* 修改内边距 */
	  height: 40px;
	  padding: 0 350px;
	  box-sizing: border-box;
	}
	
	.product-list {
	  display: flex;
	  flex-wrap: wrap;
	  width: 1200px;
	  margin: auto;
	}
	
	.product-list {
	  flex-wrap: wrap;
	
	  ::v-deep .com-product-item:nth-of-type(5n) {
	    margin-right: 0;
	  }
	
	  ::v-deep .com-product-item {
	    margin-bottom: 18px;
	  }
	}
	
	.noData {
	  background: #fff;
	  height: 200px;
	  display: flex;
	  justify-content: center;
	  align-items: center;
	
	  span {
	    font-size: 24px;
	    color: #aaa7a7;
	  }
	}
</style>